import * as Yup from 'yup';

export const validationSchemaFormMobi = Yup.object({
  otp: Yup.string()
    .required('Поле обязательно для заполнения')
    .length(5, 'Невалидный код'),
});
